import React from "react";
import Girl from "../Resources/img/home_girl.png";
import Logo from "../Resources/svg/logo_img.svg";
import OAuthButton from "../Components/authButton";

const Home = () => {
  return (
    <div className="wrap">
      <div className="content">
        <div className="home-content">
          <div>
            <img src={Logo} alt="Rimac" />
            <div className="home-content__text">
              ¡Hola! <br /> Comencemos <br />
              un <span>día genial</span>
            </div>
            <OAuthButton />
          </div>
          <img className="home-content__img" src={Girl} alt="Rimac Home" />
        </div>
      </div>
    </div>
  );
};

export default Home;
